<template>
  <div id="distribution_detail" v-if="distributeItem">
    <h2>{{distributeItem.type ? '分发游戏' : '分发测评'}}</h2>
    <div class="detail_box">
      <a-steps :current="current">
        <template v-for="(item, index) in steps">
          <a-step :key="index === 1 && distributeItem.type ? '添加游戏' : item.title" :title="index === 1 && distributeItem.type ? '添加游戏' : item.title" />
        </template>
      </a-steps>
      <div class="steps-content">
        <!-- 填写基本信息 -->
        <div v-if="current === 0" class="detail_flex part_one">
          <div>
            <div class="detail_flex item_part">
              <span>测评任务名称：</span>
              <a-input placeholder="请输入" v-model="basicInfomation.input1"/>
            </div>
            <div class="detail_flex item_part">
              <span>学生端任务别名：</span>
              <a-input placeholder="显示在学生端的任务别名" v-model="basicInfomation.input2"/>
            </div>
            <div class="detail_flex item_part">
              <span>任务描述：</span>
              <a-textarea placeholder="请输入" v-model="basicInfomation.input3" :autosize="{ minRows: 2, maxRows: 6 }" />
            </div>
            <div class="detail_flex item_part">
              <span>开始日期：</span>
              <a-date-picker placeholder="请选择" :disabledDate="disabledStartTime" v-model="basicInfomation.date1" format="YYYY-MM-DD" />
            </div>
            <div class="detail_flex item_part">
              <span>结束日期：</span>
              <a-date-picker placeholder="请选择" :disabledDate="disabledEndDate" v-model="basicInfomation.date2" format="YYYY-MM-DD" />
            </div>
          </div>
        </div>
        <!-- 添加量表 / 添加游戏 -->
        <div v-if="current === 1" class="part_two">
          <div>
            <span class="title">{{distributeItem.type ? '已选游戏：' : '已选量表：'}}</span>
            <div>
              <ul>
                <li v-for="(item, index) in tags" :key="index">{{item}}<img @click="deleteHandle(item)" src="@/assets/close.png"></li>
              </ul>
              <a-tag @click="showScaleGame" style="background: #fff; borderStyle: dashed; color: #8C8C8C;">
                <a-icon type="plus-circle" /> {{distributeItem.type ? '添加其他游戏' : '添加其他量表'}}
              </a-tag>
            </div>
          </div>
        </div>
        <!-- 设置分配范围 -->
        <div v-if="current === 2" class="part_three">
          <div>
            <span>请选择分发模式：</span>
            <div class="radios_box">
              <a-radio-group v-model="valObj">
                <a-radio :value="0" style="margin-right: 40px;">分发给群体（年级/班级）</a-radio>
                <a-radio :value="1">分发给个体（学生）</a-radio>
              </a-radio-group>
            </div>
            <span>{{valObj === 0 ? '需要分发测评的年级/班级：' : '需要分发测评的学生（学生可多选）：'}}</span>
            <div v-if="valObj === 0">
              <!-- <template v-for="(tag, index) in groupDetail">
                <a-tooltip :key="index + 'a1'" :title="tag">
                  <a-tag :key="index + 'b1'" closable :afterClose="() => handleGradeClose(tag)">{{tag}}</a-tag>
                </a-tooltip>
              </template> -->
              <ul class="add_con">
                <li v-for="(item, index) in groupDetail" :key="index + 'po'">{{item.con}}<img @click="handleGradeClose(item.con, item)" src="@/assets/close.png"></li>
              </ul>
              <a-tag style="background: #fff; borderStyle: dashed; color: #8C8C8C;" @click="addGradeHandle">
                <a-icon type="plus-circle" /> 点击添加
              </a-tag>
            </div>
            <div v-else>
              <a-tag style="background: #51BF94; color: #FFFFFF; border: none" @click="addStuHandle">
                <a-icon type="plus" /> 点击添加
              </a-tag>
              <a-table :columns="columns" :dataSource="stuInfoList" :rowKey="row => row.UID" :pagination="{ pageSize: 5 }">
                <template slot="SEX" slot-scope="text">{{text === 1 ? '男' : (text === 2 ? '女' : '未知') }}</template>
                <template slot="ENTRYYEAR" slot-scope="text">{{gradeName(text)}}</template>
                <template slot="CLASS_ID" slot-scope="text">{{`${text}班`}}</template>
                <template slot="operation" slot-scope="text, record">
                  <span style="color: #F5222D;cursor: pointer;" class="action" @click="operationHandle(record.UID, record)">删除</span>
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- 确认信息 -->
        <div v-if="current === 3" class="part_four">
          <div>
            <div class="info_top info_item" v-if="basicInfomation">
              <span>基本信息</span>
              <div>
                <span>测评任务名称：</span><span class="top_con">{{basicInfomation.input1}}</span>
              </div>
              <div>
                <span>任务描述：</span><span class="top_con">{{basicInfomation.input3}}</span>
              </div>
              <div>
                <span>学生端任务别名：</span><span class="top_con">{{basicInfomation.input2}}</span>
              </div>
              <div>
                <span>开始日期：</span><span class="top_con">{{dataFilter(basicInfomation.date1)}}</span>
              </div>
              <div>
                <span>结束日期：</span><span class="top_con">{{dataFilter(basicInfomation.date2)}}</span>
              </div>
            </div>
            <div class="info_middle info_item">
              <span>包含量表</span>
              <p>{{filterContain}}</p>
            </div>
            <div class="info_foot info_item">
              <span>分发范围</span>
              <p>分发模式：{{valObj === 0 ? '分发给群体（年级/班级）' : '分发给个体（学生）'}}</p>
              <div v-if="valObj === 0 && groupDetail">
                <a-tag v-for="(tag, index) in groupDetail" :key="index + 'c'" style="background: #E8E8E8; color: #8C8C8C;">{{tag.con}}</a-tag>
              </div>
              <div v-else>
                <a-table :columns="columnsTwo" :dataSource="stuInfoList" :rowKey="row => row.UID" :pagination="{ pageSize: 5 }">
                  <template slot="SEX" slot-scope="text">{{text === 1 ? '男' : (text === 2 ? '女' : '未知') }}</template>
                  <template slot="ENTRYYEAR" slot-scope="text">{{gradeName(text)}}</template>
                  <template slot="CLASS_ID" slot-scope="text">{{`${text}班`}}</template>
                </a-table>
              </div>
            </div>
          </div>
        </div>
        <!-- 完成 -->
        <div v-if="current === 4" class="part_five detail_flex">
          <div>
            <div style="text-align: center;">
              <img src="@/assets/complete_icon.png" alt="">
            </div>
            <span style="margin: 24px 0px 8px;">分发成功</span>
            <span style="font-size: 12px; color: #BFBFBF;">{{basicInfomation.input1}}</span>
          </div>
        </div>
      </div>
      <div class="steps-action detail_flex">
        <a-button v-if="current !== 0 && current !== 4" @click="prev" style="margin-right: 12px">上一步</a-button>
        <a-button v-if="current === 4" type="primary" style="margin-right: 12px" @click="seeTaskHandle">去查看任务</a-button>
        <a-button v-if="current === 4" @click="() => this.$router.push('/evaluationList/distributionStu')">返回</a-button>
        <a-button v-if="current === 0" :disabled="!this.basicInfomation.input1 || !this.basicInfomation.input2 || !this.basicInfomation.input3 || !dataFilter(this.basicInfomation.date1) || !dataFilter(this.basicInfomation.date2)" type="primary" @click="next">下一步</a-button>
        <a-button v-if="current === 1" :disabled="!tags.length" type="primary" @click="next">下一步</a-button>
        <a-button v-if="current === 2 && !valObj" :disabled="groupFlag" type="primary" @click="next">下一步</a-button>
        <a-button v-if="current === 2 && valObj" :disabled="!stuInfoList.length" type="primary" @click="next">下一步</a-button>
        <a-button v-if="current === 3" type="primary" @click="next" :loading="loading">下一步</a-button>
      </div>
    </div>
    <pop-one v-show="popOneShow" @addHandle="addHandle" :tags="tags"></pop-one>
    <pop-two ref="childTwo" v-show="popTwoShow" @chooseHandle="chooseHandle"></pop-two>
    <pop-three v-show="popThreeShow" ref="threePop" @isDisabled="isDisabled" :removeInfo="removeInfo" :removeInfoOne="removeGradeOne" :removeInfoTwo="removeGradeTwo"></pop-three>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapMutations, mapActions } from 'vuex'
import GradeFormat from '@/util/gradeFormat'
import PopOne from './DistributionPopBoxOne'
import PopTwo from './DistributionPopBoxTwo'
import PopThree from './DistributionPopBoxThree'
// import STUDENTFUN from '@/util/studentFun'

export default {
  name: 'DistributionDetail',
  components: {
    PopOne,
    PopTwo,
    PopThree
  },
  data () {
    return {
      current: 0, // 当前步骤数
      steps: [ // 步骤
        {
          title: '填写基本信息'
        },
        {
          title: '添加量表'
        },
        {
          title: '设置分配范围'
        },
        {
          title: '确认信息',
        },
        {
          title: '完成'
        }
      ],
      tags: [], // 已选量表列表
      valObj: 0, // 当前分发模式
      // gradeList: null, // 分发范围列表
      removeInfo: null,
      removeGradeOne: null,
      removeGradeTwo: null,
      columns: [ // 分发范围
        {
          title: '已选学生',
          dataIndex: 'REAL_NAME',
          key: 'REAL_NAME'
        },
        {
          title: '性别',
          dataIndex: 'SEX',
          key: 'SEX',
          scopedSlots: { customRender: 'SEX' }
        },
        {
          title: '年级',
          dataIndex: 'ENTRYYEAR',
          key: 'ENTRYYEAR',
          scopedSlots: { customRender: 'ENTRYYEAR' }
        },
        {
          title: '班级',
          dataIndex: 'CLASS_ID',
          key: 'CLASS_ID',
          scopedSlots: { customRender: 'CLASS_ID' }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      columnsTwo: [ // 确认信息
        {
          title: '已选学生',
          dataIndex: 'REAL_NAME',
          key: 'REAL_NAME'
        },
        {
          title: '性别',
          dataIndex: 'SEX',
          key: 'SEX',
          scopedSlots: { customRender: 'SEX' }
        },
        {
          title: '年级',
          dataIndex: 'ENTRYYEAR',
          key: 'ENTRYYEAR',
          scopedSlots: { customRender: 'ENTRYYEAR' }
        },
        {
          title: '班级',
          dataIndex: 'CLASS_ID',
          key: 'CLASS_ID',
          scopedSlots: { customRender: 'CLASS_ID' }
        }
      ],
      stuInfoList: [],
      stuInfoListNum: [],
      stuInfoListNumGroup: [],
      loading: false,
      groupFlag: true
    }
  },
  computed: {
    ...mapState([
      'popOneShow', // 单校分发测评添加量表或游戏弹窗显示与否的状态
      'popTwoShow', // 单校分发测评添加学生弹窗显示与否的状态
      'popThreeShow', // 单校分发测评添加年级/班级弹窗显示与否的状态
      'basicInfomation', // 基本信息
      'distributeItem', // 分发的量表游戏信息
      'allSurveys',
      'gameGroups',
      'schoolInfos',
      'isSingleOk',
      'gradeClass',
      'userInfo'
    ]),
    groupDetail () {
      let info = this.$refs.threePop.chooseAllInfo
      return info
    },
    filterContain () {
      return this.tags.join('、')
    }
  },
  methods: {
    ...mapMutations([
      'setPopOneShow', // 单校分发测评添加量表或游戏弹窗显示与否的状态
      'setPopTwoShow', // 单校分发测评添加学生弹窗显示与否的状态
      'setPopThreeShow', // 单校分发测评添加年级/班级弹窗显示与否的状态
      'setBasicInfomation', // 存基本信息
      'setSingleDistributePlan',
      'setDefaultData'
    ]),
    ...mapActions([
      'getAddSurveyPlan', // 量表分发
      'distributeGamesPlan', // 游戏分发
    ]),
    isDisabled (flag) { // 选中班级后边确定触发，开启下一步按钮
      this.groupFlag = flag
    },
    disabledStartTime(startValue) { // 开始时间限制
      const endValue = this.basicInfomation.date2
      if (!startValue || !endValue) {
        return startValue.valueOf() < new Date(moment(new Date()).format('YYYY-MM-DD')).valueOf()
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    disabledEndDate (endValue) { // 结束时间限制
      const startValue = this.basicInfomation.date1
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() > endValue.valueOf()
    },
    async next () { // 下一步操作
      if (this.current === 0) { // 基本信息
        if (this.basicInfomation.input1 || this.basicInfomation.input2 || this.basicInfomation.input3 || moment(this.basicInfomation.date1).format('YYYY-MM-DD') || moment(this.basicInfomation.date2).format('YYYY-MM-DD')) {
          this.setBasicInfomation({
            input1: this.basicInfomation.input1,
            input2: this.basicInfomation.input2,
            input3: this.basicInfomation.input3,
            date1: this.basicInfomation.date1,
            date2: this.basicInfomation.date2
          })
        }
      }
      if (this.current === 2 && !this.valObj) { // 群体分发
        this.stuInfoListNumGroup = []
        this.groupDetail.map((item) => {
          if (this.distributeItem.type) { // 游戏-根据选中的年级班级找到包含的学生ID
            this.schoolInfos.map((value) => {
              if (item.id === value.ENTRYYEAR) {
                if (item.classId) { // 班级
                  let classID = parseInt(item.classId.split('班')[0])
                  if (classID === value.CLASS_ID) {
                    this.stuInfoListNumGroup.push(value.UID)
                  }
                } else { // 年级
                  this.stuInfoListNumGroup.push(value.UID)
                }
              }
            })
          } else { // 量表-整合选中的所有班级
            // let stuInfoList = STUDENTFUN.testAlreadyInfo(this.schoolInfos).alreadyGoodTotal
            // let gradeClassAll = STUDENTFUN.uploadData(stuInfoList).classMaps
            if (!item.classId) { // 年级
              this.gradeClass.forEach((val) => {
                if (item.id === val.ENTRYYEAR) {
                  this.stuInfoListNumGroup.push({
                    grade: item.id,
                    class: val.CLASS_ID
                  })
                }
              })
            } else {
              this.stuInfoListNumGroup.push({
                grade: item.id,
                class: item.classId.slice(0, -1)
              })
            }
          }
        })
      }
      if (this.current === 3) { // 确认信息分发
        this.loading = true
        // 收集待分发量表ID
        let IdList = [] // 选中的游戏或量表ID
        let filterContain = this.filterContain.split('、')
        if (this.distributeItem.type) { // 游戏1
          this.gameGroups.map((item) => {
            if (filterContain.includes(item.GAME_SUMMARY)) {
              IdList.push(item.GAME_ID)
            }
          })
          if (!this.valObj) { // 群体分发
            this.stuInfoListNum = this.stuInfoListNumGroup
          }
          await this.gamePublice(IdList)
        } else { // 量表0
          this.allSurveys.map((item) => { // 选中的量表ID
            if (filterContain.includes(item.SURVEY_TITLE)) {
              IdList.push(item.ID)
            }
          })
          await this.surveyPublice(IdList)
        }
        if (this.isSingleOk) {
          this.loading = false
          this.setSingleDistributePlan(null)
        }
      }
      this.current++
    },
    async surveyPublice (IdList) { // 量表
      if (!this.valObj) { // 群体
        await this.getAddSurveyPlan({
          title: this.basicInfomation.input1,
          description: this.basicInfomation.input3,
          student_title: this.basicInfomation.input2,
          start_time: moment(this.basicInfomation.date1).format('YYYY-MM-DD'),
          end_time: moment(this.basicInfomation.date2).format('YYYY-MM-DD'),
          topics: IdList.join(','),
          class_list: this.stuInfoListNumGroup,
          type: 3
        })
      } else { // 个体
        let arr = []
        this.stuInfoList.map(item => {
          arr.push({UID: item.UID, ENTRYYEAR: item.ENTRYYEAR, CLASS_ID: item.CLASS_ID})
        })
        await this.getAddSurveyPlan({
          title: this.basicInfomation.input1,
          description: this.basicInfomation.input3,
          student_title: this.basicInfomation.input2,
          start_time: moment(this.basicInfomation.date1).format('YYYY-MM-DD'),
          end_time: moment(this.basicInfomation.date2).format('YYYY-MM-DD'),
          topics: IdList.join(','),
          student_id: arr,
          type: 1
        })
      }
    },
    async gamePublice (IdList) { // 游戏
      await this.distributeGamesPlan({
        title: this.basicInfomation.input1,
        summary: this.basicInfomation.input3,
        studentTitle: this.basicInfomation.input2,
        startTime: moment(this.basicInfomation.date1).format('YYYY-MM-DD'),
        endTime: moment(this.basicInfomation.date2).format('YYYY-MM-DD'),
        topicsArray: IdList,
        studentUids: this.stuInfoListNum
      })
    },
    prev () { // 上一步操作
      this.current--
    },
    deleteHandle (removedTag) { // 删除已添加的游戏或量表
      let tags = this.tags
      this.tags = tags.filter(tag => tag !== removedTag)
    },
    addHandle (addArr) {
      // let concatArr = this.tags
      // this.tags = Array.from(new Set(concatArr.concat(addArr)))
      this.tags = addArr
    },
    showScaleGame () { // 控制添加量表/游戏弹窗
      this.setPopOneShow(true)
    },
    handleGradeClose (removedTag, info) { // 设置分配范围中删除所选班级或年级
      let gradeList = this.$refs.threePop.chooseAllInfo
      let listOne = this.$refs.threePop.gradeInfo
      let listTwo = this.$refs.threePop.classAllArr
      const tags = gradeList.filter(tag => tag.con !== removedTag)
      this.removeInfo = tags
      if (info.classId) {
        listTwo.map(item => {
          item.map(itemOne => {
            if (info.id === itemOne.id) {
              if (info.classId === itemOne.classItem) {
                itemOne.checkFlag = false
              }
            }
          })
        })
      } else {
        listOne.map(item => {
          if (info.id === item.id) {
            item.checkAll = false
          }
        })
        listTwo.map(item => {
          item.map(itemOne => {
            if (info.id === itemOne.id) {
              itemOne.checkFlag = false
            }
          })
        })
      }
      this.removeGradeOne = listOne
      this.removeGradeTwo = listTwo
      if (this.groupDetail.length === 1) { // 页面上删除选中的班级，删除最后一个时，禁用下一步按钮
        this.groupFlag = true
      }
    },
    operationHandle (id, item) { // 设置分配范围中删除所选学生的功能
      this.stuInfoList = this.stuInfoList.filter(item => item.UID !== id)
      this.$refs.childTwo.deleteHandle(id, item)
    },
    gradeName (item) { // 转换年级
      return GradeFormat(item, this.userInfo.SCHOOL_TYPE)
    },
    dataFilter (item) {
      if (item) {
        return moment(item).format('YYYY-MM-DD')
      }
    },
    addStuHandle () { // 点击添加学生弹窗
      this.setPopTwoShow(true)
    },
    addGradeHandle () { // 点击添加年级和班级弹窗
      this.setPopThreeShow(true)
    },
    chooseHandle (list) { // 添加学生
      this.stuInfoList = list.chooseList
      this.stuInfoListNum = list.chooseListNum
    },
    seeTaskHandle () { // 去查看任务
      this.$router.push('/evaluationList/evaluationProgress')
      this.setDefaultData(['4'])
    }
  },
  mounted () {
    this.setBasicInfomation({
      input1: null,
      input2: null,
      input3: null,
      date1: null,
      date2: null
    })
    if (this.distributeItem.type) { // 游戏
      this.tags.push(this.distributeItem.GAME_SUMMARY)
    } else {
      this.tags.push(this.distributeItem.SURVEY_TITLE)
    }
  }
}
</script>

<style>
#distribution_detail {
  width: 100%;
  padding: 0px 0px 50px 0px;
  box-sizing: border-box;
}
#distribution_detail .detail_flex {
  display: flex;
  align-items: center;
}
#distribution_detail h2 {
  font-size: 24px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 24px;
}
#distribution_detail .detail_box {
  width: 100%;
  padding: 40px;
  background-color: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-sizing: border-box;
}
#distribution_detail .steps-content {
  padding-top: 40px;
  box-sizing: border-box;
}
#distribution_detail .detail_box .part_one {
  justify-content: center;
}
#distribution_detail .part_one .ant-input {
  width: 250px;
}
#distribution_detail .part_one .item_part {
  margin-bottom: 16px;
}
#distribution_detail .part_one .item_part:last-child {
  margin-bottom: 0px;
}
#distribution_detail .part_one .item_part span:first-child {
  width: 120px;
  text-align: right;
}
#distribution_detail .steps-action {
  justify-content: center;
  margin-top: 32px;
}
#distribution_detail .part_two .ant-tag, #distribution_detail .part_three .ant-tag, #distribution_detail .part_four .ant-tag {
  font-size: 14px;
  padding: 9px 16px;
  height: auto;
  margin: 16px 16px 0px 0px;
}
#distribution_detail .part_three .radios_box {
  padding: 17px 0px 33px;
  box-sizing: border-box;
}
#distribution_detail .part_four p {
  margin-bottom: 0px;
  margin-top: 16px;
}
#distribution_detail .part_four .info_item > span {
  color: #262626;
  font-size: 16px;
}
#distribution_detail .part_four .info_top > div {
  margin-top: 16px;
}
#distribution_detail .part_four .info_top .top_con {
  display: inline-block;
  margin-left: 8px;
  color: #595959;
}
#distribution_detail .part_four .info_middle, #distribution_detail .part_four .info_foot {
  margin-top: 32px;
}
#distribution_detail .part_five {
  justify-content: center;
}
#distribution_detail .part_five span {
  display: block;
  text-align: center;
  color: #262626;
  font-size: 16px;
}
#distribution_detail .ant-steps-item-process .ant-steps-item-icon, #distribution_detail .ant-btn-primary {
  background-color: #51BF94;
  border-color: #51BF94;
  color: #FFFFFF;
}
#distribution_detail .ant-btn-primary:hover, #distribution_detail .ant-btn-primary[disabled] {
  color: #FFFFFF;
  background-color: rgba(81, 191, 148, .6);
  border-color: rgba(81, 191, 148, .6);
}
#distribution_detail .ant-steps-item-finish .ant-steps-item-icon {
  border-color: #51BF94;
}
#distribution_detail .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  color: #51BF94;
}
#distribution_detail .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title::after {
  background-color: #51BF94;
}
#distribution_detail .part_three .ant-table-wrapper, #distribution_detail .part_four .ant-table-wrapper {
  margin-top: 24px;
}
#distribution_detail .part_three .ant-table-pagination.ant-pagination, #distribution_detail .part_four .ant-table-pagination.ant-pagination {
  margin: 24px 0px 0px;
}
#distribution_detail .part_two ul, #distribution_detail .part_three .add_con {
  padding: 0px;
  margin-top: 16px;
  display: inline-block
}
#distribution_detail .part_two ul li, #distribution_detail .part_three .add_con li {
  display: inline-block;
  margin-bottom: 10px;
}
#distribution_detail .part_two ul li, #distribution_detail .part_three .add_con li {
  height: 35px;
  line-height: 35px;
  padding: 0px 15px;
  background: #E8E8E8;
  border: 0px;
  color: #262626;
  font-size: 14px;
  margin-right: 10px;
  border-radius: 4px;
}
#distribution_detail .part_two ul li img, #distribution_detail .part_three .add_con li img {
  width: 16px;
  height: auto;
  margin-left: 10px;
  cursor: pointer;
}
</style>
